var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["material-notification__item__alert", _vm.data.type] },
    [
      _c("p", [_vm._v(_vm._s(_vm.data.message))]),
      _vm._v(" "),
      _c("i", {
        staticClass: "fal fa-times-circle",
        attrs: { role: "button" },
        on: { click: _vm.onClose },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }